export default "__VITE_ASSET__BAO8W5Es__"